interface ApiSuccess<T> {
  ok: true;
  data: T;
}

interface ApiFailure {
  ok: false;
  error: string;
}

export async function postSession<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(path, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const payload = (await response.json()) as ApiSuccess<T> | ApiFailure;
  if (!response.ok || !payload.ok)
    throw new Error(payload.ok ? 'The session request failed.' : payload.error);
  return payload.data;
}

export async function deleteSession<T>(path: string): Promise<T> {
  const response = await fetch(path, { method: 'DELETE', credentials: 'same-origin' });
  const payload = (await response.json()) as ApiSuccess<T> | ApiFailure;
  if (!response.ok || !payload.ok)
    throw new Error(payload.ok ? 'The session request failed.' : payload.error);
  return payload.data;
}

export async function uploadSessionFile<T>(path: string, file: File): Promise<T> {
  const separator = path.includes('?') ? '&' : '?';
  const response = await fetch(`${path}${separator}name=${encodeURIComponent(file.name)}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': file.type },
    body: file
  });
  const payload = (await response.json()) as ApiSuccess<T> | ApiFailure;
  if (!response.ok || !payload.ok)
    throw new Error(payload.ok ? 'The upload failed.' : payload.error);
  return payload.data;
}
